const fichaAviso = {
  postPostulacion: {
    subscriptionCheck: false,
  },
}

export default fichaAviso
